// const fs = require('fs');
// const path = require('path');
// const s3Streamlogger = require('s3-streamlogger').S3StreamLogger;
// const { createLogger, format, transports } = require('winston');
// const { combine, timestamp, label, printf } = format;
// const util = require('util');

import axios from "axios";

// function transform(info, opts) {
//   const args = info[Symbol.for('splat')];
//   if (args) { info.message = util.format(info.message, ...args); }
//   return info;
// }

// function utilFormatter() { return {transform}; }


// var s3stream = new s3Streamlogger({
//   bucket: "projects-log-management",
//   folder: "2022/events/eslides-engagement/",
//   access_key_id: "AKIA3L54ROGDDLPWSM53",
//   secret_access_key: "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"
// });

// const myFormat = printf(({ level, label, message, timestamp, json }) => {
//   return `${timestamp} ${message}`;
// });

// var streamTransport = new (transports.Stream)({
//   stream: s3stream
// });

// export default createLogger({
//   format: combine(
//     format.prettyPrint(),
//     format.splat(),
//     format.simple(),
//     timestamp({ format: 'YYYY-MM-DD HH:mm:ss' }),
//     utilFormatter(), 
//     myFormat
//   ),
//   transports: [
//     streamTransport,
//     new transports.File({ filename: 'combined.log' })
//   ]
// });

export default function LogManager(message: String) {
  try {
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_ENDPOINT}/api/logger/add`,
      data: {
        message,
      },
    });
  } catch (error) {
    console.error(error)
  }
}



